import { defineStore } from "pinia";
import { ref } from "vue";
//@ts-ignore
import { TABTYPE } from "@customTypes/HomeTabTypeEnum";
export var useHomeTabStore = defineStore("homeTabStoreId", function () {
  var activeTab = ref(TABTYPE.SALE);
  var isTabActive = function isTabActive(tab) {
    return activeTab.value === tab;
  };
  return {
    activeTab: activeTab,
    isTabActive: isTabActive
  };
});